import React from 'react';
import { Skeleton } from '../Skeleton';

const CertificateCard = () => {
  return (
    <div className="w-100 certificatesCardV1Box shadow rounded-3 position-relative overflow-hidden cursorPointer">
      <Skeleton variant="rectangular" width={'100%'} height={150} />
    </div>
  );
};

export default CertificateCard;
